<script>
    import {onMount} from "svelte";
    import Spinner from "./components/spinner.svelte";
    import Header from "./components/header.svelte";
    import Subscription from "./subscriptions/subscriptionform.svelte";        
    import Message from "./components/message.svelte"
    let isPageLoading;

    onMount(async()=>{
        isPageLoading=true;
        //getServices();
        //getLAs();
        isPageLoading=false;
    })
    
    let ShowPending=false;
    let showSuccessMessage = false;
</script>

<svelte:head>
    <title>Register | Wavenet Nimbus</title>
</svelte:head>

{#if isPageLoading}
   <Spinner/>  
{:else}
    <Header login={true} accessDenied={false} isRegisterPage={true}></Header>
    <main>
	    <div class="d-flex flex-row">
            <div class="container main-content pt-3">
                <div class="row">
                    <div class="card mb-3" style="width:100%" >
                        <div class="card-body with-table">
                            <div class="row mb-3">
                                <div class="col-12">
                                    <img src="/images/register.jpg" width="100%" alt="Help image" />
                                </div>
                            </div>

                            <div class="row m-0 p-0">
                                {#if showSuccessMessage}
                                    <Message Type="Success">
                                        <div slot="header">You have successfully registered your interest!</div>
                                        <div slot="content">
                                            <p>
                                                One of our team will be in touch shortly. If you have any
                                                questions in the meantime, please <a href="https://www.wavenet.co.uk/contact-us" target="_blank">get in contact</a>.
                                            </p>
                                            <a href="https://nimbus.adept.education" class="btn btn-primary">Return</a>
                                        </div>
                                    </Message>
                               {:else}
                                    <div class="col-md-12 ">
                                        <h3>Sign up</h3>
                                        <p>To get started, or to receive further information, please complete the form and one of our team will get back to you.</p>
                                        <hr />
                                    </div>
                                    <Subscription {ShowPending} on:added={()=> showSuccessMessage = true} ButtonText="Submit Interest"></Subscription>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
{/if}

<style>
    .custom-checkbox label {
        position: relative;
        margin-bottom: 0;
        vertical-align: top;
    }
        .custom-checkbox label::before {
            -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            position: absolute;
            top: 0.15625rem;
            left: -1.5rem;
            display: block;
            width: 1rem;
            height: 1rem;
            pointer-events: none;
            content: "";
            border-radius: 0;
            border: 2px solid #2e817d;
            background-color: transparent;
        }
        .custom-checkbox label::after {
            position: absolute;
            top: 0.15625rem;
            left: -1.5rem;
            display: block;
            width: 1rem;
            height: 1rem;
            content: "";
            background: no-repeat 50% / 50% 50%;
        }
    .custom-checkbox input[type="checkbox"] {
        box-sizing: border-box;
        padding: 0;
        position: absolute;
        z-index: -1;
        opacity: 0;
    }
</style>